import { render, staticRenderFns } from "./ExpensesStaffAndPayroll.vue?vue&type=template&id=3caf00df"
import script from "./ExpensesStaffAndPayroll.vue?vue&type=script&lang=js"
export * from "./ExpensesStaffAndPayroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports